(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7722],{

/***/ 80324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ TagsContext; },
/* harmony export */   "M": function() { return /* binding */ TagsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);


var TagsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var TagsProvider = function(param) {
    var children = param.children, tags = param.tags;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagsContext.Provider, {
        value: {
            tags: tags
        },
        children: children
    });
};


/***/ }),

/***/ 47722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TagsWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Tag/index.tsx + 1 modules
var Tag = __webpack_require__(32486);
// EXTERNAL MODULE: ./components/cms/Tags/Tags.module.scss
var Tags_module = __webpack_require__(10396);
var Tags_module_default = /*#__PURE__*/__webpack_require__.n(Tags_module);
// EXTERNAL MODULE: ./components/cms/Tags/TagsContext.tsx
var TagsContext = __webpack_require__(80324);
;// CONCATENATED MODULE: ./components/cms/Tags/Tags.tsx





var Tags = function(param) {
    var tags = param.tags;
    var contextTags = (0,react.useContext)(TagsContext/* TagsContext */.j);
    if (!contextTags) return;
    var tmp = contextTags.tags, renderTags = tmp === void 0 ? [] : tmp;
    if (!renderTags) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Tags_module_default()).container,
        children: renderTags === null || renderTags === void 0 ? void 0 : renderTags.map(function(tag, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                label: tag
            }, i);
        })
    });
};
/* harmony default export */ var Tags_Tags = (Tags);

;// CONCATENATED MODULE: ./components/cms/Tags/index.tsx

/* harmony default export */ var cms_Tags = (Tags_Tags);

;// CONCATENATED MODULE: ./storyblok/components/TagsWrapper.tsx


function TagsWrapper(param) {
    var tags = param.tags;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cms_Tags, {
        tags: tags
    });
};


/***/ }),

/***/ 10396:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container___m_I_"};

/***/ })

}]);